import { JsonSchema } from '@sagold/react-json-editor';

import { unique } from '../../../utils/unique';

type EnumValue = string | number | boolean | null;

function getEnumValues(value: unknown): EnumValue[] {
  const values = Array.isArray(value) ? value : [value];

  return values.filter((item): item is EnumValue => {
    return (
      item === null ||
      typeof item === 'string' ||
      typeof item === 'number' ||
      typeof item === 'boolean'
    );
  });
}

function disableValidation(schema: JsonSchema): void {
  schema.options = {
    ...schema.options,
    showErrors: false,
    required: false,
  };

  delete schema.required;
  delete schema.minItems;
}

function allowEnumValues(schema: JsonSchema, values: EnumValue[]): void {
  if (Array.isArray(schema.enum)) {
    schema.enum = unique([...(schema.enum as EnumValue[]), ...values]);
  }
}

/** Allow stored display values during parent revalidation in readonly mode. */
export function relaxReadonlySchemaConstraints(
  schema: JsonSchema,
  value: unknown
): void {
  disableValidation(schema);
  allowEnumValues(schema, [null, ...getEnumValues(value)]);

  if (
    schema.items != null &&
    typeof schema.items === 'object' &&
    !Array.isArray(schema.items) &&
    Array.isArray(schema.items.enum)
  ) {
    disableValidation(schema.items);
    allowEnumValues(schema.items, [null, ...getEnumValues(value)]);
  }
}
